import React from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';
import DifficultySelection from '../components/DifficultySelection';
import Layout from '../components/Layout';
import { getPersonalities } from '../data/personalities';
import { generateCharacter } from '../utils/characterGenerator';

const VALID_GENDERS = ['male', 'female'];

const DifficultyPage = () => {
  const { isKeyValid, trialMode, trialBlock } = useApiKey();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const gender = searchParams.get('gender');

  const trialActive = trialMode && trialBlock !== 'trial_exhausted' && trialBlock !== 'owner_out_of_credits';
  const canPractice = isKeyValid || trialActive;

  // Gate: can't practice, or arrived without a valid gender — bounce back.
  if (!canPractice) return <Navigate to="/" replace />;
  if (!VALID_GENDERS.includes(gender)) return <Navigate to="/" replace />;

  // Pick a random personality at the chosen difficulty (or from all of them for
  // "Random"), then drop straight into the timed Date in Eight chat.
  const startChallenge = (level) => {
    const all = getPersonalities(gender);
    const pool = level === 'Random' ? all : all.filter((p) => p.difficulty === level);
    const personality = pool[Math.floor(Math.random() * pool.length)];
    const character = generateCharacter(personality, gender);
    navigate('/chat', { state: { personality, character, freeMode: false, gameMode: true } });
  };

  return (
    <Layout>
      <DifficultySelection
        onSelectDifficulty={startChallenge}
        onBack={() => navigate(`/mode?gender=${gender}`)}
      />
    </Layout>
  );
};

export default DifficultyPage;
